import { ICollectionTile } from "@faire/web-api/indigofair/data/ICollectionTile";
import React from "react";

export interface ICollectionTileImpressionContextValue {
  containerName?: string;
  requestId: string | undefined;
  contextToken: string | undefined;
  screenContext: ICollectionTile.Screen | undefined;
  containerContext: ICollectionTile.ScreenContainer | undefined;
  brandPromoToken?: string;
}

export const CollectionTileClickImpressionContext =
  React.createContext<ICollectionTileImpressionContextValue>({
    screenContext: ICollectionTile.Screen.SCREEN_UNKNOWN,
    containerContext: ICollectionTile.ScreenContainer.SCREEN_CONTAINER_UNKNOWN,
    requestId: undefined,
    contextToken: undefined,
  });
CollectionTileClickImpressionContext.displayName =
  "CollectionTileClickImpressionContext";
